import { useAssociationListStore } from '@/modules/profile-page/stores/AssociationsListStore';
export const initAssociationsList = (associationList: string[]) => {
  const associationsListStore = useAssociationListStore();

  associationsListStore.$patch((state) => {
    state.associationList = associationList;
  });
};
